/* eslint-disable react/no-danger */
/* eslint-disable import/no-unresolved */
import React from 'react';
import _ from 'lodash';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Grid, Pagination } from 'swiper/modules';
import BoxedContainer from './layouts/BoxedContainer';
import 'swiper/css/bundle';
import 'swiper/css/grid';
import 'swiper/css/pagination';

function FreeZoneKeyBenefitsListSlider({ id, data }) {
  const title = _.get(data, 'title', '');
  const bgImage = _.get(data, 'bgImage', {});
  const bgImageMobile = _.get(data, 'bgImageMobile', {});
  const itemsList = _.get(data, 'itemsList', []);

  // const breakpoints = {
  //   640: {
  //     slidesPerView: 3,
  //     spaceBetween: 16,
  //     grid: {
  //       fill: 'row',
  //       rows: 2,
  //     },
  //   },
  //   1024: {
  //     slidesPerView: 5,
  //     spaceBetween: 40,
  //     grid: {
  //       fill: 'row',
  //       rows: 1,
  //     },
  //   },
  //   1280: {
  //     slidesPerView: 7,
  //     spaceBetween: 40,
  //     grid: {
  //       fill: 'row',
  //       rows: 1,
  //     },
  //   },
  // };

  return (
    <section id={id} className="bg-red relative overflow-hidden">
      {_.isEmpty(bgImage) || (
        <LazyLoadImage
          src={bgImage.url}
          alt="bg texture"
          className="absolute hidden md:block inset-0 object-cover 
          h-full w-full bg-blend-multiply opacity-15"
        />
      )}

      {_.isEmpty(bgImageMobile) || (
        <LazyLoadImage
          src={bgImageMobile.url}
          alt="bg texture"
          className="absolute md:hidden inset-0 object-cover h-full w-full 
          mix-blend-multiply opacity-15"
        />
      )}

      <BoxedContainer
        className="pb-[60px] pt-12.5 md:py-16 lg:py-20 flex flex-col gap-7 md:gap-y-[50px] xl:py-25
      xl:!max-w-[1430px] lg:px-0">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          viewport={{ once: true }}
          className="w-full flex flex-col items-center gap-5">
          <div
            className="child:text-clamp20to40 child:ltr:!font-URWDINMedium
            child:rtl:!font-GESSTwoDWTCMedium child:leading-[1.3]
            last:child:!m-0 child:text-center child:text-white"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <div className="py-px bg-white w-10 lg:w-12.5 lg:mb-1.25" />
        </motion.div>
        <div className="w-full">
          {/* <Swiper
            modules={[Grid, Pagination]}
            spaceBetween={16}
            pagination
            slidesPerView={2}
            breakpoints={breakpoints}
            grid={{
              fill: 'row',
              rows: 2,
            }}
            className="gap-8 pb-[50px] lg:pb-0 swiper-pagination:md:hidden
            swiper-pagination-bullet-active:!bg-white swiper-pagination-bullet:!border-white
            swiper-pagination-bullet:border-[1px] swiper-pagination-bullet:!bg-transparent
            swiper-pagination-bullet:!opacity-[100]">
            {_.map(itemsList, (item, key) => {
              const itemTitle = _.get(item, 'content.title', '');
              const itemImage = _.get(item, 'content.keyListImage', {});

              return (
                <SwiperSlide key={key} className="">
                  <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.3 * (key + 1) }}
                    className="flex flex-col items-center mb-2 lg:m-0 lg:max-w-42.5 gap-5">
                    {_.isEmpty(itemImage) ? (
                      <i className="w-16 h-16 rounded-full bg-white bg-opacity-30" />
                    ) : (
                      <LazyLoadImage
                        src={itemImage.url}
                        alt={itemTitle}
                        className="w-[67px] md:w-[90px] h-[67px] md:h-[90px] object-cover"
                      />
                    )}
                    <span className="text-center text-white text-clamp14to20 
                    ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight ltr:leading-1 rtl:leading-[1.3]0">
                      {itemTitle}
                    </span>
                  </motion.div>
                </SwiperSlide>
              );
            })}
          </Swiper> */}

          <div
          className="lg:pb-0 gap-4 gap-y-7 md:gap-0
          flex flex-wrap [&>*]:flex-grow justify-center
          [&>*]:md:max-w-[25%] [&>*]:sm:max-w-[33.3333%] [&>*]:max-w-[calc(50%-8px)]
          [&>*]:lg:max-w-[20%] [&>*]:xl:max-w-[16.6666666667%] [&>*]:2xl:max-w-[14.2857142857%]
          ">
            {_.map(itemsList, (item, key) => {
              const itemTitle = _.get(item, 'content.title', '');
              const itemImage = _.get(item, 'content.keyListImage', {});

              return (
                <div key={key} className="md:p-4">
                  <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.3 * (key + 1) }}
                    className="flex flex-col items-center mb-2 lg:m-0 lg:max-w-42.5 gap-5">
                    {_.isEmpty(itemImage) ? (
                      <i className="w-16 h-16 rounded-full bg-white bg-opacity-30" />
                    ) : (
                      <LazyLoadImage
                        src={itemImage.url}
                        alt={itemTitle}
                        className="w-[67px] md:w-[90px] h-[67px] md:h-[90px] object-cover"
                      />
                    )}
                    <div className="text-center text-white text-clamp14to20 space-y-4
                    ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight [&>*]:mb-0 [&>*]:text-white
                    leading-[1.4]" 
                    dangerouslySetInnerHTML={{__html:itemTitle}} />
                  </motion.div>
                </div>
              );
            })}
            </div>
        </div>
      </BoxedContainer>
    </section>
  );
}

export default FreeZoneKeyBenefitsListSlider;
